import { translateField } from "@cdv/jazz-i18n";
import { Button, Stack, Typography } from "@mui/material";
import { ReactElement, useContext } from "react";
import AppBar from "../ui/AppBar";
import { Resource } from "../utils";
import { useNavigate } from "react-router";
import { ActionType, AppContext } from "@cdv/jazz-ui";

export default function Content(): ReactElement {
  const navigate = useNavigate();
  const { getUrl } = useContext(AppContext);
  const buttonCss = {
    width: "210px",
  };

  return (
    <>
      <AppBar title={translateField(Resource.Info, "title")} />

      <Stack sx={{ justifyContent: "center", minHeight: "78vh", mt: "0 !important" }} spacing={2}>
        <Stack sx={{ alignItems: "center" }}>
          <img src="/assets/ilustr_INFO_01.svg" style={{ height: "150px" }} />
        </Stack>

        <Typography sx={{ textAlign: "center" }}>
          Protistresová aplikace <br /> poskytující psychologické služby <br /> profesionálním
          řidičům{" "}
        </Typography>

        <Stack spacing={2} sx={{ alignItems: "center" }}>
          <Button
            variant="contained"
            size="large"
            sx={buttonCss}
            onClick={() => navigate(getUrl(Resource.Info, ActionType.SHOW, { id: "about" }))}
          >
            O aplikaci
          </Button>
          <Button
            variant="contained"
            size="large"
            sx={buttonCss}
            onClick={() => navigate(getUrl(Resource.Info, ActionType.SHOW, { id: "contact" }))}
          >
            Kontakt a podpora
          </Button>
          <Button
            variant="contained"
            size="large"
            sx={buttonCss}
            onClick={() =>
              navigate(getUrl(Resource.Info, ActionType.SHOW, { id: "personal-data" }))
            }
          >
            Podmínky a GDPR
          </Button>
          {/* <Button
            variant="contained"
            size="large"
            sx={buttonCss}
            onClick={() => navigate(getUrl(Resource.Info, ActionType.SHOW, { id: "terms" }))}
          >
            Podmínky používání
          </Button> */}
          <Button
            variant="contained"
            size="large"
            color="error"
            sx={buttonCss}
            onClick={() => navigate(getUrl(Resource.Info, ActionType.SHOW, { id: "help" }))}
          >
            najít pomoc
          </Button>
        </Stack>

        <Typography
          sx={{ textAlign: "center", fontSize: "11px", color: "#00000099", mt: "50px !important" }}
        >
          StressOFF Verze 1.0.0 (100) <br /> © 2026 Centrum dopravního výzkumu <br />
          Všechna práva vyhrazena.
        </Typography>
      </Stack>
    </>
  );
}
